module.exports = __webpack_public_path__ + "static/media/190611_BarRaye-02.a2996c73.png";